<template>
  <div>
    <div v-if="cartItem" class="d-flex justify-space-between align-center">
      <div class="d-flex cart-item" :class="unavailable ||
          $wait.is(
            `loading clickAndCollect fetchDiscounts ${cartItem.base64Id}`
          )
          ? 'cart-item-disabled'
          : ''
        ">
        <div>
          <div style="cursor: pointer; position: relative" @click="goToProductDetails(cartItem)" class="py-2 pr-2">
            <v-img :src="cartItem.imageUrl" max-width="100"></v-img>
            <FixitFavorite v-if="isUserFavorite"/>
          </div>
        </div>
        <div class="cart-item-description">
          <div style="cursor: pointer" @click="goToProductDetails(cartItem)">
            <p class="mb-0">{{ cartItem.name }}</p>
          </div>
          <p class="mb-1 text-body-2">{{ cartItem.brandName }}</p>
          <p v-if="isAdditionalProduct" class="mb-1 text-body-2 font-italic">
            Du kvalifiserer til å få dette produktet gratis!
          </p>
          <div style="font-size: 12px; color: #e46574; width: 80px">
            <span v-if="onlyOneItemLeft(cartItem)">(Kun 1 igjen)</span>
          </div>
          <div v-for="disc in discounts" :key="disc.campaignId" v-show="!unavailable">
            <small style="color: red; font-weight: normal" v-html="disc.discountText"></small>
          </div>
          <div class="d-flex align-center" v-if="!unavailable">
            <v-icon size="40" :disabled="$wait.is(
              `loading clickAndCollect updateCartItemQuantity ${cartItem.id}`
            ) || cartItem.quantity == 1
              " :style="isAdditionalProduct ? 'visibility: hidden' : ''" color="primary"
              @click="updateItemQuantity(cartItem, $event, 'decrease')">
              fxt-minus-circle
            </v-icon>
            <div class="px-3 text-h5">{{ cartItem.quantity }}</div>
            <v-icon size="40" :disabled="$wait.is(
              `loading clickAndCollect updateCartItemQuantity ${cartItem.id}`
            ) || onlineStock == cartItem.quantity
              " :style="isAdditionalProduct ? 'visibility: hidden' : ''" color="primary"
              @click="updateItemQuantity(cartItem, $event, 'increase')">
              fxt-plus-circle
            </v-icon>
          </div>
          <div v-else>Produktet er ikke tilgjengelig lenger</div>
        </div>
      </div>
      <div class="d-flex align-center">
        <div>
          <v-col class="hidden-xs-only text-right d-flex flex-column" style="white-space: nowrap; justify-content: center"
            v-if="!unavailable">
            <span :style="{
              'font-size': itemDiscount.discounted ? '14px' : '16px',
              'text-decoration': itemDiscount.discounted
                ? 'line-through'
                : '',
              'font-weight': itemDiscount.discounted ? 'normal' : '',
            }">kr {{ itemDiscount.totalValue | currency(2, 2) }}</span>
            <span style="color: red; font-size: 16px" v-if="itemDiscount.discounted">
              kr {{ itemDiscount.totalSalePrice | currency(2, 2) }}</span>
          </v-col>
        </div>
        <div>
          <v-col class="align-self-center text-center px-3" cols="1" v-show="inCart">
            <v-icon color="primary" @click="removeItemFromCart(cartItem)" :disabled="$wait.is(
              `loading clickAndCollect fetchDiscounts ${cartItem.base64Id}`
            )
              ">fxt-trash</v-icon>
          </v-col>
        </div>
      </div>
    </div>
    <hr v-if="!inCart" class="mt-4" style="
        border-image: linear-gradient(
            90deg,
            var(--v-primary-base) 0%,
            var(--v-primary-base) 51.04%,
            var(--v-primary-base) 100%
          )
          1;
      " />
    <div v-if="!inCart" class="d-flex justify-space-between align-center my-2" :class="inCart ? 'pr-12' : ''">
      <p class="mb-0 total-price">Totalt kroner</p>
      <div>
        <v-col class="text-right d-flex flex-column" style="white-space: nowrap; justify-content: center">
          <span :style="{
            'font-size': '16px',
            'text-decoration': '',
            'font-weight': '',
          }">kr {{ itemDiscount.totalSalePrice | currency(2, 2) }}</span>
        </v-col>
      </div>
    </div>
  </div>
</template>
<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import FixitFavorite from "./FixitFavorite.vue"
export default {
  mixins: [webshopMixins],
  components: {
    FixitFavorite
  },
  props: {
    cartItem: Object,
    inCart: Boolean,
    unavailable: Boolean,
  },
  methods: {},
  computed: {
    isAdditionalProduct() {
      return this.cartItem.discounts.find((d) => d.isAdditionalProduct) != null;
    },
    isUserFavorite() {
      return this.$store.getters['favorites/getFavoriteProuct'](this.cartItem.id) != null
    },
    discounts() {
      return this.cartItem?.discounts.filter(
        (x) => x.originalPrice != x.discountPrice
      );
    },
    onlineStock() {
      var cartItemStock = this.cartItem.stockAmount;
      var activeSites = this.salons.map((s) => s.siteId) || [];
      var onlineStocks = cartItemStock
        .filter((x) => activeSites.includes(x.siteId))
        ?.map((x) => x.productStockAmount);
      var onlineStock = onlineStocks.length
        ? onlineStocks.reduce((a, b) => a + b)
        : 0;
      return onlineStock;
    },
    itemDiscount() {
      if (this.cartItem) {
        var salePrice = this.cartItem.price;
        var totalPriceForQuantity = 0;
        var discountedQuantity = 0;
        if (this.cartItem.discounts.length) {
          this.cartItem.discounts.forEach((discount) => {
            if (discount.discountPrice < discount.originalPrice) {
              totalPriceForQuantity +=
                discount.discountPrice * discount.quantity;
              discountedQuantity += discount.quantity;
            }
          });
        } else {
          totalPriceForQuantity = salePrice * this.cartItem.quantity 
        }
        if (
          discountedQuantity <= this.cartItem.quantity &&
          discountedQuantity > 0
        ) {
          totalPriceForQuantity +=
            this.cartItem.price * (this.cartItem.quantity - discountedQuantity);
          salePrice = totalPriceForQuantity / this.cartItem.quantity;
        }
        return {
          salePrice: salePrice,
          price: this.cartItem.price,
          totalSalePrice:
            totalPriceForQuantity,
          totalValue: this.cartItem.price * this.cartItem.quantity,
          discounted: discountedQuantity > 0,
        };
      }
      return {
        salePrice: 0,
        price: 0,
        totalSalePrice: 0,
        totalValue: 0,
        discounted: true,
      };
    },
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style scoped lang="scss">
.total-price {
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;

  &__price {
    font-size: 22px;
    font-weight: 700;
    line-height: 20px;
  }
}

.cart-item {
  &-disabled {
    opacity: 0.5;
  }

  &-description {
    align-self: center;
  }
}
</style>
